import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CampaignVideo } from '../models/campaignVideo';

@Injectable({ providedIn: 'root' })
export class CampaignVideoService {
  constructor(private http: HttpClient) {}

  getVideos(campaignId: string): Observable<CampaignVideo[]> {
    const url = `${environment.apiUrl}campaigns/${campaignId}/videos`;
    return this.http.get<CampaignVideo[]>(url);
  }

  addVideo(campaignId: string, videoUrl: string): Observable<CampaignVideo> {
    const url = `${environment.apiUrl}campaigns/${campaignId}/videos`;
    return this.http.post<CampaignVideo>(url, { url: videoUrl });
  }

  refreshVideo(campaignId: string, videoId: string): Observable<CampaignVideo> {
    const url = `${environment.apiUrl}campaigns/${campaignId}/videos/${videoId}/refresh`;
    return this.http.post<CampaignVideo>(url, null);
  }

  deleteVideo(campaignId: string, videoId: string): Observable<void> {
    const url = `${environment.apiUrl}campaigns/${campaignId}/videos/${videoId}`;
    return this.http.delete<void>(url);
  }

  getPublicVideos(campaignId: string): Observable<CampaignVideo[]> {
    const url = `${environment.apiUrl}public/campaigns/${campaignId}/videos`;
    return this.http.get<CampaignVideo[]>(url);
  }
}
